import Loader from '@anm/components/Loader';
import { flexCenter, media } from '@anm/styles/helpers';
import styled from 'styled-components';

const wrapperOnMobiles = media.tablet`
  display: block;
`;

const howToSectionOnMobiles = media.tablet`
  margin-top: 30px;
  margin-left: 0;
`;

export const Wrapper = styled.div`
  padding: 30px 24px;
  display: flex;

  ${wrapperOnMobiles};
`;

export const LeftSide = styled.div`
  max-width: 360px;
`;

export const LoaderWrapper = styled(Loader)`
  margin-top: 100px;
`;

export const HowToSection = styled.div`
  margin-left: 48px;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #8b9499;
  max-width: 550px;
  ${howToSectionOnMobiles};
`;

export const Subtitle = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #8b9499;
  margin-bottom: 10px;
`;

export const ListWrapper = styled.ol`
  padding: 0;
  margin: 0;
  list-style: none;
  margin-bottom: 31px;
  counter-reset: counter;
`;

export const Step = styled.li`
  font-style: normal;
  display: flex;
  counter-increment: counter;

  &:before {
    content: counter(counter);
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    background: #f3f6f7;
    border-radius: 50%;
    margin-right: 10px;
    ${flexCenter};
  }

  &:not(:last-child) {
    margin-bottom: 20px;
  }

  b {
    display: contents;
  }
`;

export const LabelExplanation = styled.div`
  display: flex;
  align-items: center;

  p {
    margin: 0 0 0 10px;
  }

  &:not(:last-of-type) {
    margin-bottom: 12px;
  }
`;
